import { render, staticRenderFns } from "./VSelectUniversity.vue?vue&type=template&id=0d408f7f&"
import script from "./VSelectUniversity.vue?vue&type=script&lang=js&"
export * from "./VSelectUniversity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d408f7f')) {
      api.createRecord('0d408f7f', component.options)
    } else {
      api.reload('0d408f7f', component.options)
    }
    module.hot.accept("./VSelectUniversity.vue?vue&type=template&id=0d408f7f&", function () {
      api.rerender('0d408f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectUniversity.vue"
export default component.exports